import { GetServerSidePropsResult, GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import getPublicConfig from '@/utils/getPublicConfig';

import Discussion from '@/types/Discussions';
import DiscussionPage from '@/domains/discussions';
import discussionService from '@/services/discussionService';

type PageProps = {
  discussion: Discussion;
};

const publicRuntimeConfig = getPublicConfig();

function DiscussionBySlugPage({ discussion }: PageProps): JSX.Element {
  const { title, slug } = discussion;

  const ogUrl = `${publicRuntimeConfig.LOCATION_ORIGIN}/discussions/${slug}`;

  const openGraph = {
    type: 'article',
    site_name: 'OneVillage',
    url: ogUrl,
    title,
  };

  return (
    <>
      <NextSeo title={title} openGraph={openGraph} />
      <DiscussionPage discussion={discussion} />
    </>
  );
}

export default DiscussionBySlugPage;

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<PageProps>> {
  const { slug } = context?.params || {};

  const { discussion, error } = await discussionService.getBySlug(
    slug as string,
  );

  if (error) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      discussion,
    },
  };
}
